import React from 'react';

export default function FAQ3(){
    return(
        <div className="question mt-40">
            <h4 className="h-4 h-bold">
                Estimates
            </h4>
            <div className="questions">
                <h6 className="h-6 bold-500 text-left">
                    How do I create an estimate?
                </h6>
                <p className="paragraph p-adjustment text-left">
                    To create an estimate, select Quotes from the menu. Create your estimate from there by filling in the client's details, adding items, and your estimate is ready! 
                </p>
                <h6 className="h-6 bold-500 text-left">
                     How do I customize my estimate?
                </h6>
                <p className="paragraph p-adjustment text-left">
                     You can customize your estimate from the settings. Choose the layout and add the company logo and any banners or watermarks of choice. You can change the overall look of your estimate by changing the colors
                </p>
            </div>
        </div>
    )
}